import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import MobileBottomBar from '../../components/feature/MobileBottomBar';
import HeroSection from './components/HeroSection';
import FeaturedDishes from './components/FeaturedDishes';
import StorySection from './components/StorySection';
import MenuPreview from './components/MenuPreview';
import AmbianceSection from './components/AmbianceSection';
import ReviewsSection from './components/ReviewsSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <div className="bg-cream">
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedDishes />
        <StorySection />
        <MenuPreview />
        <AmbianceSection />
        <ReviewsSection />
        <CTASection />
      </main>
      <Footer />
      <MobileBottomBar />
    </div>
  );
}
